document.addEventListener('DOMContentLoaded', function () {
    let isLoading = false;

    const loadMorePosts = (loadMoreButton, type) => {
        const queryEl = loadMoreButton.closest('.wp-block-vayu-blocks-advance-query-loop');
        const anchor = loadMoreButton.querySelector('.th-button-inside');
        const page = parseInt(loadMoreButton.getAttribute('data-page'));
        const maxPage = parseInt(loadMoreButton.getAttribute('data-max-page'));
        const perPage = parseInt(loadMoreButton.getAttribute('data-per-page'));
        const currentPath = window.location.pathname;
        const wpBase = currentPath.split('/')[1];

        if (page > maxPage) {
            return;
        }

        isLoading = true;
        anchor.textContent = loadMoreButton.getAttribute('data-loadmore-label');
        loadMoreButton.setAttribute('disabled', 'disabled');

        const block = JSON.parse(queryEl.getAttribute('data-attrs'));
        const ajaxUrl = `${window.location.origin}/${wpBase}/wp-admin/admin-ajax.php`;
        const data = new FormData();
        data.append('action', 'load_more_posts');
        data.append('page', page);
        data.append('perpage', perPage);
        data.append('query_id', loadMoreButton.getAttribute('data-query-id'));
        data.append('attrs', JSON.stringify(block));

        fetch(ajaxUrl, {
            method: 'POST',
            body: data,
        })
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    const content = data.data.content;
                    const wrapper = document.querySelector('.wp-block-vayu-blocks-wrapper');

                    if (wrapper) {
                        wrapper.insertAdjacentHTML('beforeend', content);
                    }

                    // Update the page number
                    loadMoreButton.setAttribute('data-page', page + 1);
                    loadMoreButton.setAttribute('data-current-page', page);

                    // Check if we've reached the max page
                    if (page + 1 > maxPage) {
                        anchor.textContent = loadMoreButton.getAttribute('data-nomorepost-label');
                        loadMoreButton.setAttribute('disabled', 'disabled');
                    } else {
                        anchor.textContent = loadMoreButton.getAttribute('data-loadmorebtn-txt');
                        loadMoreButton.removeAttribute('disabled');
                    }
                } else {
                    console.error('Error fetching posts:', data);
                    anchor.textContent = loadMoreButton.getAttribute('data-loadmorebtn-txt');
                    loadMoreButton.removeAttribute('disabled');
                }
            })
            .catch(error => {
                console.error('Error:', error);
                anchor.textContent = loadMoreButton.getAttribute('data-loadmorebtn-txt');
                loadMoreButton.removeAttribute('disabled');
            })
            .finally(() => {
                isLoading = false;
            });
    };

    const initLoadMore = () => {
        const loadMoreButton = document.querySelector('.load-more-btn');
        if (!loadMoreButton) return;

        loadMoreButton.addEventListener('click', function (event) {
            const loadtype = loadMoreButton.getAttribute('data-loadmore-type');
            if (loadtype === 'loadmorebtn') {
                event.preventDefault();
                loadMorePosts(loadMoreButton, loadtype);
            }
        });
    };

    const initInfiniteScroll = () => {
        window.addEventListener('scroll', function () {
            const loadMoreButton = document.querySelector('.load-more-btn');
            if (!loadMoreButton || isLoading) return;

            const rect = loadMoreButton.getBoundingClientRect();
            const windowHeight = window.innerHeight || document.documentElement.clientHeight;

            if (rect.top - windowHeight < 100) {
                const loadtype = loadMoreButton.getAttribute('data-loadmore-type');
                if (loadtype === 'loadinfinite') {
                    loadMorePosts(loadMoreButton, loadtype);
                }
            }
        });
    };

    // Initialize both behaviors
    initLoadMore();
    initInfiniteScroll();
});
